import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { getGoFoTrackingDetails } from '../../store/actions/batch.action';
import Modal from "react-bootstrap/Modal";
import LoaderSpinner from '../common/Loader';
import './tracking.css';

const GoFoTrackingDetails = (props) => {
    const { trackingNumber, item, ...modalProps } = props;
    const [showLoader, setShowLoader] = React.useState(false);
    const [trackingResponse, setTrackingResponse] = React.useState({});
    const [errorDetails, setErrorDetails] = React.useState({ show: false, message: '' });

    useEffect(() => {
        fetchTrackingDetails();
    }, [trackingNumber]);

    const fetchTrackingDetails = async () => {
        const trackingDetails = {
            trackingNumber: trackingNumber,
        };
        setShowLoader(true);
        const res = await getGoFoTrackingDetails(trackingDetails);
        if (res.data.Status === 200) {
            setTrackingResponse(res.data.Entity);
            setErrorDetails({ show: false, message: '' });
        } else {
            setErrorDetails({ show: true, message: res.data.Message.AppStatusDescription });
        }
        setShowLoader(false);
    };

    // GoFo API returns "Data" (capital D); lowercase "data" kept as defensive fallback.
    // API returns multiple events; show only the most recent (first) one.
    const allEvents = trackingResponse?.Data || trackingResponse?.data || [];
    const trackingEvents = allEvents.slice(0, 1);

    return (
        <Modal {...modalProps} className="modalDeleteWrapper" size="lg">
            <Modal.Header closeButton>
                <div className="modal-main-div">
                    <span className="modal-m-text">Tracking History {showLoader && <LoaderSpinner />}</span>
                </div>
            </Modal.Header>
            <Modal.Body className="fontFix trackingModal">
                <div className='mb-1'>
                    <div className='heading mb-1'>Tracking: {trackingNumber}</div>
                    <div>{item?.ReceiverName}</div>
                    <div>{item?.ReceiverAddressLine1}</div>
                    <div>{item?.ReceiverAddressLine2}</div>
                    <div>{item?.ReceiverAddressLine3}</div>
                    <div>{item?.ReceiverCity} {item?.ReceiverState} {item?.ReceiverZip} {item?.CountryCode}</div>
                </div>
                <div className="trackingBox pt-1">
                    <div className="timeline">
                        {trackingEvents?.map((event, index) => (
                            <div className={`timeline-item ${(event.EnContext || '').includes('Delivered') ? 'delivered' : ''}`} key={index}> {/* NOSONAR */}
                                <div className="status">{event.EnContext || event.PubEsContext || '-'}</div>
                                {event.Operator && <div className="sub-status">{event.Operator}</div>}
                                {event.Location && <div className="location">{event.Location}</div>}
                                <div className="date">
                                    {event.OperationTime || '-'}
                                    {event.GroupTimeZone ? ` (${event.GroupTimeZone})` : ''}
                                </div>
                                {event.ThirdWaybillNo && (
                                    <div className="sub-status">Waybill: {event.ThirdWaybillNo}</div>
                                )}
                                {event.OrderNo && (
                                    <div className="sub-status">Order: {event.OrderNo}</div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                {errorDetails.show && (
                    <div className="error-message tracking">{errorDetails.message}</div>
                )}
            </Modal.Body>
        </Modal>
    );
};

GoFoTrackingDetails.propTypes = {
    trackingNumber: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired
};

export default GoFoTrackingDetails;
